import { Component, OnInit } from "@angular/core";
import { CtaButtonsComponent } from "src/app/components/cta-buttons/cta-buttons.component";
import { ReactiveTextInputComponent } from "src/app/components/inputs/reactive-text-input/reactive-text-input.component";
import { starterPages } from "../starter-data";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { StarterFormDataService } from "../starter-form-data.service";
import { ReactiveNgSelectFieldComponent } from "src/app/components/inputs/reactive-ng-select-field/reactive-ng-select-field.component";
import { bankOptions, resolveBankName } from "../starter-data";
import { BankOption } from "../starter-data";
import { lastValueFrom } from "rxjs";
import { SharedModule } from "src/app/shared.module";
import { NavigationEnd, Router } from "@angular/router";

@Component({
  selector: "app-account-details",
  standalone: true,
  templateUrl: "./account-details.component.html",
  styleUrls: ["./account-details.component.scss"],
  imports: [
    ReactiveTextInputComponent,
    CtaButtonsComponent,
    ReactiveNgSelectFieldComponent,
    SharedModule
  ],
})
export class AccountDetailsComponent implements OnInit {
  starterPages: string[] = starterPages;
  bankOptions: BankOption[] = bankOptions;
  bankNames: string[] = [];
  bankName: FormControl = new FormControl();
  accountName: FormControl = new FormControl();
  accountNumber: FormControl = new FormControl();
  minNum: number = 10; // Default minNum
  maxNum: number = 12; // Default maxNum
  isAllFilled = false;

  formData: any = {
    bankName: null,
    accountName: null,
    accountNumber: null,
  };
  formGroup: FormGroup;

  constructor(private starterService: StarterFormDataService, router: Router) {
    router.events.subscribe((val) => {
      // see also 
      
      if(val instanceof NavigationEnd) {
        console.log("navigated to ",val) 
        
          this.starterService.getMerchantDetailsV2().subscribe((data: any) => {
            console.log("router data", data)
            this.starterService.merchantData = data;
            const fullName = `${this.starterService.merchantData.first_name} ${this.starterService.merchantData.last_name}`;
            this.starterService.merchantData = data;
            this.bankName.setValue(
              resolveBankName(
                this.starterService.merchantData.bank_details.bank_name
              )
            );
            this.accountName.setValue(
              fullName
              // this.starterService.merchantData.bank_details.account_name,
            );
            this.accountNumber.setValue(
              this.starterService.merchantData.bank_details.account_number
            );

            this.bankName.setValue(
              resolveBankName(
                this.starterService.merchantData.bank_details.bank_name
              )
            );
            this.accountName.setValue(
              `${this.starterService.merchantData.first_name} ${this.starterService.merchantData.last_name}`
              // this.starterService.merchantData.bank_details.account_name,
            );
            this.accountNumber.setValue(
              this.starterService.merchantData.bank_details.account_number
            );
        
            console.log('account name value', this.accountName.value);                    
          });
        
    

      }
    });

    this.formGroup = new FormGroup({
      bankName: this.bankName,
      accountName: this.accountName,
      accountNumber: this.accountNumber,
    });

    this.bankName.valueChanges.subscribe((value) => {
      this.formData.bankName = value;
      this.updateBankDetails(value);
      this.checkRequiredFields();
    });

    this.accountName.valueChanges.subscribe(() => {
      this.formData.accountName = this.accountName.value;
      this.checkRequiredFields();
    });

    this.accountNumber.valueChanges.subscribe(() => {
      this.formData.accountNumber = this.accountNumber.value;
      this.checkRequiredFields();
    });
  }

  checkRequiredFields() {
    this.isAllFilled =
      this.bankName.valid && this.accountName.valid && this.accountNumber.valid;
  }

  ngOnInit() {
    this.starterService.setCheckPointIndex(3);
    window.parent.postMessage(JSON.stringify({ event: 'track_event', name: 'f_o400_account_details_view'}), '*');
    const fullName = `${this.starterService.merchantData.first_name} ${this.starterService.merchantData.last_name}`;
    this.bankNames = this.bankOptions.map((bank) => bank.name);
    if (typeof this.starterService.merchantData === "undefined") {
      this.starterService.getMerchantDetailsV2().subscribe((data: any) => {
        this.starterService.merchantData = data;
        this.bankName.setValue(
          resolveBankName(this.starterService.merchantData.bank_details.bank_name),
        );
        this.accountName.setValue(
          fullName
          // this.starterService.merchantData.bank_details.account_name,
        );
        this.accountNumber.setValue(
          this.starterService.merchantData.bank_details.account_number,
        );
      });
    } else {
      this.bankName.setValue(
        resolveBankName(this.starterService.merchantData.bank_details.bank_name),
      );
      this.accountName.setValue(
        fullName
        // this.starterService.merchantData.bank_details.account_name,
      );
      this.accountNumber.setValue(
        this.starterService.merchantData.bank_details.account_number,
      );
    }

    this.bankName.setValue(
      resolveBankName(this.starterService.merchantData.bank_details.bank_name),
    );
    this.accountName.setValue(
      fullName
      // this.starterService.merchantData.bank_details.account_name,
    );
    this.accountNumber.setValue(
      this.starterService.merchantData.bank_details.account_number,
    );

    console.log('account name value', this.accountName.value);
  }

  // check if form is valid
  checkIfFormIsValid() {
    this.isAllFilled = this.formGroup.valid;
  }



  updateBankDetails(bankName: string) {
    const selectedBank = this.bankOptions.find(
      (bank) => bank.name === bankName,
    );
    if (selectedBank) {
      this.minNum = selectedBank.minNum;
      this.maxNum = selectedBank.maxNum;
    } else {
      this.minNum = 10; // Default minNum
      this.maxNum = 12; // Default maxNum
    }
  }

  handleNext = async () => {
    var merchantData = this.starterService.merchantData;
    merchantData.bank_details.bank_name = this.bankName.value;
    merchantData.bank_details.account_number = this.accountNumber.value;
    merchantData.bank_details.account_name = this.accountName.value;
    merchantData.account_number = this.accountNumber.value;
    merchantData.bank_name = this.bankName.value;
    merchantData.account_name = this.accountName.value;
    console.log("bank account", merchantData)
    await lastValueFrom(this.starterService.updateBankAccountDetails(merchantData));
    return lastValueFrom(this.starterService.updateMerchantDetails(merchantData)).then((response) => {
      if (response) {
        window.parent.postMessage(JSON.stringify({ event: 'track_event', name: 'f_o410_account_details_success'}), '*');
      } else {
        window.parent.postMessage(JSON.stringify({ event: 'track_event', name: 'f_o411_account_details_failure'}), '*');
      }
      return response;
    });
    // process.env["START_SUCCESS_URL"]
  }
}
